var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexRowClass logoContainer"},[_c('div',{staticStyle:{"padding-top":"15px"}},[_c('img',{staticStyle:{"height":"60px"},attrs:{"src":_vm.showLogo}})]),_c('div',{staticStyle:{"margin-left":"10px","color":"#FFFFFF","z-index":"100","font-size":"22px","font-weight":"600"}},[_vm._v(" "+_vm._s(_vm.showTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }